import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App grain-overlay">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(212,175,55,0.35)",
              color: "#ffffff",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
